import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ShippingMode } from '../../models/shipping-mode';
import { Country } from '../../address/address/address.component';
import { Cart } from '../../../../projects/shared-lib/src/lib/models/cart';
import { CartElement } from '../../../../projects/shared-lib/src/lib/models/cart-element';
import { CartService } from '../../shared/services/cart.service';
import { ShippingModeComponent } from '../shipping-mode/shipping-mode.component';
import { TwUrlPipe } from '../../shared/pipe/tw-url-pipe/tw-url.pipe';

@Component({
    selector: 'tw-shipping-modes-list',
    templateUrl: './shipping-modes-list.component.html',
    styleUrls: ['./shipping-modes-list.component.css'],
    imports: [ShippingModeComponent, TwUrlPipe]
})
export class ShippingModesListComponent implements OnInit, OnChanges, OnDestroy {
    @Input() idsPerformance: any[];
    @Input() shippingModeList: ShippingMode[];
    @Input() cart: Cart;

    @Input()
    set data(value: Country) {
        const isCanada = value.country.toLowerCase() === 'ca' || value.country.toLowerCase() === 'canada';
        if (isCanada) {
            this.territory = value.province;
        }
        if (!isCanada) {
            this.territory = 'HORS_CANADA';
        }

    }

    territory: string;


    constructor(public cartService: CartService) {

    }


    ngOnInit() {
        //console.log(this.idsPerformance);
        if(this.shippingModeList){
            this.shippingModeList?.forEach(value => {
                const event = this.getEventFormCart(value.event.id);
                if (event) {
                    value.event.eventStart = event.eventStart;
                    value.event.title = event.title;
                }
            });
        }

    }

    ngOnChanges(changes: SimpleChanges) {

    }

    ngOnDestroy(): void {

    }

    getEventFormCart(eventId): CartElement {
        let event: CartElement = null;
        const cart = this.cartService.cartSub.value
        cart.cartElements.forEach(cartElement => {
            if (eventId === cartElement.id) {
                event = cartElement;
            }
        });
        return event;
    }

}
